enum TRACKING_EVENTS {
  DISCOVERY_CONTENT_IMPRESSION = 'DCI',
  DISCOVERY_CONTENT_CLICK = 'DCC',
  PAGE_VIEW = 'PV',
  RCBP_HOMEPAGE_LOAD = 'RCBPHPGL',
  RCBP_ACTION = 'RCBPACT',
  RCBP_SEARCH_PAGE_LOAD = 'RCBPSPL',
  RCBP_SELECT_PLAN_LOAD = 'RCBPSPPL',
  RCBP_FILTER_APPLIED = 'RCBPFilterApplied',
  RCBP_PLAN_SELECTED = 'RCBPPS',
  RCBP_PAYMENTS_LOAD = 'RCBPPL',
  RCBP_PAYMENTS_CONTINUE = 'RCBPPC',
  RCBP_EDIT_OPERATOR_CONTINUE = 'RCBPECC',
  RCBP_CLIENT_ERROR_EVENT = 'CEE',
  RCBP_IMPRESSION = 'RCBPIMP',
  RCBP_BILL_DETAILS = 'RCBPBD',
  RCBP_UPI_PAYMENT_ACCOUNT_LOAD = 'UPIPAL',
  RCBP_UPI_ACTION = 'UPIA',
}

export default TRACKING_EVENTS
